import Vue from 'vue'
import { Toast, Popup, Loading } from 'vant'
import API from '@/api'
import VueTypedJs from 'vue-typed-js'
import App from './App.vue'
import router from './router'
import store from './store'
import {
  isWeiXin,
  Cookies,
  setSession,
  getSession,
  removeSession,
  getUID,
  Qs,
  doWxAuth,
  removeUriParams,
} from '@/utils'
import 'vant/lib/index.css'
import config from './config/index'
import '@less/index.less'
import 'animate.css'
import ShareConfig from './components/shareConfig'
import redirect from './redirect'

redirect(Vue)
Vue.use(ShareConfig)
Vue.use(VueTypedJs)
/* eslint-disable */
Vue.use(Toast)
Vue.use(Popup)
Vue.use(Loading)

Vue.config.productionTip = false

// console.log(process.env)

function doWeixinAuth(needAuth = false) {
  if (!needAuth) {
    return true
  }

  const userId = Cookies.get('user_id')
  const accessKey = Cookies.get('access_key')
  const wid = Cookies.get('wid') // unionid
  const nickname = Cookies.get('nickname')
  let activtiyUnionid = Cookies.get('activtiy_unionid')
  let auth = true
  const uri = window.location.href
  const authBack = getSession('authBack')

  console.log('authBack:', authBack, !!authBack)
  if (authBack) {
    removeSession('authBack')
    activtiyUnionid = wid
    Cookies.set('activtiy_unionid', wid, {
      expires: 60,
      domain: '.knowyourself.cc',
    })
    if (nickname) {
      Cookies.set('nickname', nickname, {
        expires: 60,
        domain: '.knowyourself.cc',
      })
    }
  }

  console.log('activtiyUnionid:', activtiyUnionid, accessKey)
  if (!activtiyUnionid || activtiyUnionid === 'undefined' || !accessKey || !userId) {
    auth = false
    console.log('非静默授权===>')

    setSession('authBack', 1)
    // 以后都用newAuth，对应source为0，只有第一个knock项目用老的授权
    window.location = `${config.authApi}/weixin/authorize?source=12&uri=${encodeURIComponent(
      removeUriParams(uri, ['token']),
    )}`
    return false
  }

  if (auth) {
    let puid = Cookies.get('puid')
    if (!puid) {
      puid = getUID()
      Cookies.set('puid', puid, {
        expires: 60,
      })
    }
  }
  return true
}

function doNewAuth(needAuth = false, forceAuth = false) {
  if (!needAuth) {
    return true
  }

  const query = Qs.parse(window.location.search ? window.location.search.substr(1) : '')
  let { token } = query
  let count = Number(getSession('auth_count')) || 0
  count += 1
  if (count > 5) {
    return false
  }
  const uri = window.location.href
  if (token) {
    setSession('token', token)
  } else {
    token = getSession('token')
  }

  if (!token || forceAuth) {
    setSession('auth_count', count)
    // 以后都用newAuth，对应source为0，只有第一个knock项目用老的授权
    window.location.replace(
      `https://wx.knowyourself.cc/wechat/oauth?url=${encodeURIComponent(
        removeUriParams(uri, ['token']),
      )}&source=0`,
    )
    return false
  }

  let userInfo = getSession('USER_INFO')
  userInfo = userInfo ? JSON.parse(userInfo) : {}

  if (!userInfo || !userInfo.userCode) {
    removeSession('auth_count')

    API.getLifeUserInfo(token)
      .then((res) => {
        if (res.err === 1002) {
          removeSession('token')
          doNewAuth(needAuth, true)
          return
        }
        setSession('USER_INFO', res.data)
        store.dispatch('setStoreUserInfo', res.data)
      })
      .catch((err) => {
        console.error(err)
      })
    // return false
  }
  return true
}

// 跳转前更新
router.beforeEach((to, from, next) => {
  Toast.clear()
  const {
    params: { query: need_auth = true },
    path,
  } = to
  console.log('need_auth:', need_auth, to)
  // 以后都用newAuth，对应source为0，只有第一个knock项目用老的授权
  const result = path.includes('knock') ? doWeixinAuth(need_auth) : doNewAuth(need_auth)
  if (result) {
    const isLifeHall = to.path.includes('lifehall')
    const el = document.getElementById('lisfhall_audio')

    if (isLifeHall && !el) {
      const audio = document.createElement('audio')
      audio.setAttribute('id', 'lisfhall_audio')
      audio.setAttribute('preload', 'auto')
      audio.setAttribute('loop', 'loop')
      audio.setAttribute(
        'src',
        'https://cdn-static.knowyourself.cc/activity_h5/lifehall/life_hall_bg.mp3',
      )
      document.body.appendChild(audio)
    }
    next()
  }
})

let isPlay = false
// 全局路由跳转后监听
router.afterEach((to, from) => {
  console.log('路由跳转 ===>', to, from)

  // 微信签名
  const isWX = isWeiXin()
  const cb = (to.path.includes('lifehall') && !isPlay)
    ? () => {
      const el = document.getElementById('lisfhall_audio')
      isPlay = true
      if (el) {
        el.play()
      }
    }
    : () => {}
  if (isWX) {
    doWxAuth({}, cb)
  }
})

// Vue.prototype.$toast = Toast

Vue.prototype.$showLoading = (message = '') => {
  Toast.loading({
    mask: true,
    message,
  })
  // store.dispatch('showLoading', message)
}

Vue.prototype.$hideLoading = () => {
  Toast.clear()
  // store.dispatch('hideLoading', message)
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
